import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const EnquiryService = (props) => {
  const { t, service, isActive } = props;

  const typeColor = {
    EVACUATION: "#32A728",
    DELIVERY: "#0A4986",
    NONE: "#008395",
  };
  const serviceText = {
    EVACUATION: "PRODUCTS_FILTER_REMOVAL",
    DELIVERY: "PRODUCTS_FILTER_SUPPLY",
    NONE: "PRODUCTS_FILTER_OTHER",
  };
  return (
    <>
      <DivBackgroundOpacity opacity={isActive === true ? 1 : "0.2"}>
        <ColumnButton
          border={typeColor[service]}
          background={typeColor[service]}
          marginRight="10px"
        >
          <span>{t(serviceText[service])}</span>
        </ColumnButton>
      </DivBackgroundOpacity>
    </>
  );
};

EnquiryService.defaultProps = {
  isActive: true,
};

EnquiryService.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  service: PropTypes.string.isRequired,
};

export default withTranslation()(EnquiryService);
